import { render, staticRenderFns } from "./IntercomsList.vue?vue&type=template&id=3d5368a4&"
import script from "./IntercomsList.vue?vue&type=script&lang=js&"
export * from "./IntercomsList.vue?vue&type=script&lang=js&"
import style0 from "./IntercomsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports